import { Component } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';

import { MAILADDVIEWLABELS } from '../../_constants/constants';
import { CustomerService } from '../../_services/customer.service';

import { TranslatePipe } from '../../shared/translate/translate.pipe';

export interface MailaddModel {
  title: string;
  current_address_label: string;
  new_address_label: string;
  description: string;
  subValue: string;
  opcoValue: string;
  customerService: CustomerService;
}

@Component({
  templateUrl: 'mail.add.dialog.component.html',
  providers: [TranslatePipe]
})

export class MailaddComponent extends DialogComponent<MailaddModel, string> implements MailaddModel {
  subValue: string;
  opcoValue: string;
  title: string;
  new_address_label = 'New Email';
  current_address_label = 'Current Email';
  oldMail: string;
  newMail: string;
  description = 'Enter the new email address';
  mailaddviewlabels = MAILADDVIEWLABELS;
  customerService: CustomerService;
  requiredErrorMsg: string = "";
  isMailError: boolean = false;
  mailErrorMsg:string="";
  constructor(private ds: DialogService, private translatePipe: TranslatePipe) {
    super(ds);

    this.isMailError = false;
    this.mailErrorMsg="";
    this.requiredErrorMsg = this.translatePipe.transform("REQUIRED_FIELD", 'CLIENT_SIDE_VALIDATION_ERROR');
  }

  setCustomValidity(event) {

    if (event.target.value === '') {
      event.target.setCustomValidity(this.translatePipe.transform("REQUIRED_FIELD", 'CLIENT_SIDE_VALIDATION_ERROR'));
    } else if (event.target.validity.typeMismatch || event.target.validity.patternMismatch) {
      event.target.setCustomValidity(this.translatePipe.transform("INVALID_EMAIL_ADDRESS", 'CLIENT_SIDE_VALIDATION_ERROR'));
    } else {
      event.target.setCustomValidity('');
    }

    return true;
  }

  setCustomValidityBlank(event) {
    event.target.setCustomValidity('');
  }


  keyDownEvent(e) {

    if (e.which === 32)
      e.preventDefault();    
      this.isMailError = false;
      this.mailErrorMsg='';
  }

  mouseHover(event) {

    event.target.setAttribute("title", "");

    // if (event.target.value == "") {
    //   event.target.setAttribute("title", this.translatePipe.transform("REQUIRED_FIELD", 'CLIENT_SIDE_VALIDATION_ERROR'))
    // }
    // else {
    //   event.target.setAttribute("title", "")
    // }
  }

  apply(formData: any) {

    if (!(this.newMail) || (this.newMail === null) || (this.newMail.trim() == "") || (this.newMail === undefined)) {

      formData.form.controls['newMailAdd'].markAsDirty();
      formData.form.controls['newMailAdd'].markAsTouched();
      formData.form.controls['newMailAdd'].setErrors({ 'required': true });
      return;
    }

    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.newMail.trim().toLowerCase())){}
    else{
        this.isMailError = true;
        this.mailErrorMsg = this.translatePipe.transform('INVALID_EMAIL_ADDRESS', 'CLIENT_SIDE_VALIDATION_ERROR')           
        return;
    }
    
    this.customerService.updateMail(this.newMail, this.subValue, this.opcoValue, this.ds);
    this.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/details/mailadd/mail.add.dialog.component.ts